import { render, staticRenderFns } from "./DocumentOmtTabContent.vue?vue&type=template&id=46c00182&scoped=true&"
import script from "./DocumentOmtTabContent.vue?vue&type=script&lang=js&"
export * from "./DocumentOmtTabContent.vue?vue&type=script&lang=js&"
import style0 from "./DocumentOmtTabContent.vue?vue&type=style&index=0&id=46c00182&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c00182",
  null
  
)

export default component.exports